'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.School = exports.Organization = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    display: grid;\n    grid-template-rows: auto auto 1fr auto;\n    align-content: space-between;\n    padding: ', 'em;\n    border-radius: 3px;\n    text-align: center;\n    line-height: 1.4em;\n    border: 1px solid ', ';\n    & > img {\n        display: block;\n        border-radius: 50%;\n        margin: 0 auto;\n    }\n    & > div:last-child {\n        border-top: 1px solid ', ';\n        background: #F7F9FA;\n        padding: ', 'em ', 'em ', 'em ', 'em;\n        margin: -', 'em;\n        margin-top: ', 'em;\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n        justify-content: space-between;\n        & > span {\n          font-size: 0.8em;\n          & svg {\n            font-size: 1.4em;\n            margin-top: -0.2em;\n          }\n          &:first-child {\n            text-align: left;\n          }\n          &:last-child {\n            text-align: right;\n          }\n        }\n    }\n'], ['\n    display: grid;\n    grid-template-rows: auto auto 1fr auto;\n    align-content: space-between;\n    padding: ', 'em;\n    border-radius: 3px;\n    text-align: center;\n    line-height: 1.4em;\n    border: 1px solid ', ';\n    & > img {\n        display: block;\n        border-radius: 50%;\n        margin: 0 auto;\n    }\n    & > div:last-child {\n        border-top: 1px solid ', ';\n        background: #F7F9FA;\n        padding: ', 'em ', 'em ', 'em ', 'em;\n        margin: -', 'em;\n        margin-top: ', 'em;\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n        justify-content: space-between;\n        & > span {\n          font-size: 0.8em;\n          & svg {\n            font-size: 1.4em;\n            margin-top: -0.2em;\n          }\n          &:first-child {\n            text-align: left;\n          }\n          &:last-child {\n            text-align: right;\n          }\n        }\n    }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    & > img {\n        border-radius: 0;\n        width: auto;\n        height: auto;\n        max-width: 50%;\n    }\n'], ['\n    & > img {\n        border-radius: 0;\n        width: auto;\n        height: auto;\n        max-width: 50%;\n    }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _iosPerson = require('react-icons/lib/io/ios-person');

var _iosPerson2 = _interopRequireDefault(_iosPerson);

var _bookmark = require('react-icons/lib/io/bookmark');

var _bookmark2 = _interopRequireDefault(_bookmark);

var _styles = require('./styles');

var _LazyImg = require('./LazyImg');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var PADDING = 1;
var HALF_PADDING = PADDING / 2;

var Organization = exports.Organization = (0, _styledComponents2.default)(function (props) {
  return _react2.default.createElement(
    'div',
    { className: props.className },
    _react2.default.createElement(_LazyImg.LazyImg, { src: props.image, alt: props.name, height: 100 }),
    _react2.default.createElement(
      'h3',
      null,
      props.name
    ),
    props.children,
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(_bookmark2.default, null),
        ' ',
        props.courses + ' ' + props.courses_title,
        ' '
      ),
      _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(_iosPerson2.default, null),
        ' ',
        props.teachers + ' ' + props.teachers_title
      )
    )
  );
})(_templateObject, PADDING, _styles.styles.colors.lightborder, _styles.styles.colors.lightborder, HALF_PADDING, PADDING, HALF_PADDING, PADDING, PADDING, PADDING);
Organization.displayName = 'Organization';

var School = exports.School = (0, _styledComponents2.default)(Organization)(_templateObject2);
School.displayName = 'School';


//////////////////
// WEBPACK FOOTER
// ../tutellus-ui/lib/Channel.js
// module id = 601
// module chunks = 0